import React, { useCallback, useState } from 'react';

function useFilter(value, data) {
  const result = useCallback(() => {
    if (!value || value == '' || value == '') {
      return data;
    }
    let _res = data.filter(_ => {
      return Object.values(_)
        .join('')
        .toLowerCase()
        .includes(value.toLowerCase());
    });
    return _res;
  }, [value, data]);
  return result();
}

export default useFilter;
